<template>
  <div id="app">
    <div
      v-if="showPasswordExpiryBanner"
      class="password-expiry-banner"
      role="alert"
    >
      <span>
        Your password expires {{ passwordExpiryBannerText }}.
        <router-link to="/change-password" class="password-expiry-banner__link">Change it now</router-link>
      </span>
      <button type="button" class="password-expiry-banner__dismiss" @click="dismissPasswordExpiryBanner" aria-label="Dismiss">
        &times;
      </button>
    </div>
    <router-view :key="$route.fullPath"></router-view>
    <MobileBottomNav />
  </div>
</template>

<script>
/* eslint-disable */
import MobileBottomNav from "@/components/employeeSelfService/MobileBottomNav.vue";

export default {
  name: "App",
  components: { MobileBottomNav },
  data() {
    return {
      showPasswordExpiryBanner: false,
      passwordExpiryBannerText: ""
    };
  },
  mounted() {
    this.refreshPasswordExpiryBanner();
    window.addEventListener("storage", this.refreshPasswordExpiryBanner);
    window.addEventListener("hb-password-expiry-updated", this.refreshPasswordExpiryBanner);
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.refreshPasswordExpiryBanner);
    window.removeEventListener("hb-password-expiry-updated", this.refreshPasswordExpiryBanner);
  },
  methods: {
    refreshPasswordExpiryBanner() {
      if (sessionStorage.getItem("passwordExpiryBannerDismissed") === "true") {
        this.showPasswordExpiryBanner = false;
        return;
      }
      const expiring = sessionStorage.getItem("passwordExpiringSoon") === "true";
      if (!expiring || sessionStorage.getItem("isLoggedIn") !== "true") {
        this.showPasswordExpiryBanner = false;
        return;
      }
      const daysRaw = sessionStorage.getItem("passwordDaysRemaining");
      const days = daysRaw != null && daysRaw !== "" ? parseInt(daysRaw, 10) : null;
      if (days === 0) {
        this.passwordExpiryBannerText = "today";
      } else if (days === 1) {
        this.passwordExpiryBannerText = "tomorrow";
      } else if (days != null && !Number.isNaN(days)) {
        this.passwordExpiryBannerText = `in ${days} days`;
      } else {
        this.passwordExpiryBannerText = "soon";
      }
      this.showPasswordExpiryBanner = true;
    },
    dismissPasswordExpiryBanner() {
      sessionStorage.setItem("passwordExpiryBannerDismissed", "true");
      this.showPasswordExpiryBanner = false;
    }
  }
};
</script>

<style>
.password-expiry-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  background: #fef3c7;
  color: #92400e;
  border-bottom: 1px solid #fcd34d;
  font-size: 14px;
  line-height: 1.4;
  z-index: 9999;
  position: relative;
}
.password-expiry-banner__link {
  color: #b45309;
  font-weight: 600;
  text-decoration: underline;
}
.password-expiry-banner__dismiss {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #92400e;
  padding: 0 4px;
}
</style>